import { getGhostBumpState } from './ghostBump';
import GhostBumpIcon from './GhostBumpIcon';
import './GhostBump.css';

const GhostBumpControl = ({ game }) => {
  const ghost = getGhostBumpState(game);
  if (!ghost.owned) return null;
  return (
    <div className="coreboundGhostBumpSetup">
      <div>
        <strong>
          <GhostBumpIcon className="coreboundGhostBumpLabelIcon" /> Ghost Bump{' '}
          <small>EPIC · ACTIVE</small>
        </strong>
        <span role="status">
          {ghost.used
            ? 'Used for this Core fight'
            : 'Ready · Bump the Core’s die while it moves · One use per fight'}
        </span>
      </div>
    </div>
  );
};

export default GhostBumpControl;
